import React, { useEffect, useState } from "react";
import DefaultLayout from "../../Defaultlayout/DefaultLayout";
import {
  API_BASE_URL,
  DELETE_DOCTOR,
  DELETE_LOCATION,
  directToken,
} from "../services/end_points";
import { _get } from "../services/service_api";
import axios from "axios";
import {
  Button,
  Card,
  Col,
  Input,
  Modal,
  Row,
  Table,
  Typography,
  Grid,
} from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import AddArea from "./AddArea";
import EditArea from "./EditArea";
import { useRoleData } from "../Data/Roledata";

const { useBreakpoint } = Grid;
const AreaList = ({ handleRole }) => {
  const { column, rows } = useRoleData({ handleRole });
  const isAdmin = rows.some((row) => row.userType === "Admin");
  const [location, setLocation] = useState([]);
  const [filteredLocation, setFilteredLocation] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [alert, setAlert] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const showModal = () => setIsModalVisible(true);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const closeModal = () => {
    setIsModalVisible(false);
    setIsEditing(false);
  };

  const userId = localStorage.getItem("userid");

  useEffect(() => {
    fetchData();
  }, [currentPage, pageSize]);

  const fetchData = async () => {
    try {
      const headers = {
        "authentication-token": `${directToken}`,
      };

      const response = await axios.get(
        `${API_BASE_URL}/location/location-list/${userId}?page=${currentPage}&size=${pageSize}`,
        { headers }
      );

      if (response.data && response.data.list) {
        setLocation(response.data.list);
        setFilteredLocation(response.data.list);
        setTotal(response.data.total || response.data.list.length);
      } else {
        console.error("Response data is not as expected:", response.data);
      }
    } catch (error) {
      console.error("Error fetching locations:", error.message);
    }
  };
  const handleDelete = (data) => {
    axios
      .delete(`${API_BASE_URL}${DELETE_LOCATION}${data}`)
      .then((response) => {
        setAlert({
          type: "success", // Set this to 'error' if needed
          message: response.data.message || "Appt Deleted!",
        });
        fetchData();
      })
      .catch((error) => {
        console.error("Error deleting Location:", error);
      });
  };

  const handleEdit = (record) => {
    setSelectedRecord(record);
    setIsModalVisible(true);
    setIsEditing(true);
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "serialNumber",
      key: "serialNumber",
      render: (_, __, index) => (currentPage - 1) * pageSize + index + 1, // Dynamically calculated
    },
    {
      title: "Area",
      dataIndex: "area",
      key: "area",
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
    },
    {
      title: "Hospital",
      dataIndex: "hospitalName",
      key: "hospitalName",
    },
    {
      title: "Action",
      key: "action",
      render: (record) => (
        <>
          <Button
            size="small"
            style={{
              fontSize: "12px",
              padding: "4px 8px",
              border: "1px solid #0899f9",
              color: "#0899f9",
            }}
            onClick={() => handleEdit(record)}
          >
            <EditOutlined />
          </Button>
          {isAdmin && (
            <Button
              size="small"
              style={{
                marginLeft: "5px",
                fontSize: "12px",
                padding: "4px 8px",
                border: "1px solid #941717",
                color: "#941717",
              }}
              onClick={() => handleDelete(record.id)}
            >
              <DeleteOutlined />
            </Button>
          )}
        </>
      ),
    },
  ];

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const screens = useBreakpoint();
  let modalWidth;
  if (screens.xl) {
    modalWidth = 600;
  } else if (screens.lg) {
    modalWidth = 550;
  } else if (screens.md) {
    modalWidth = 400;
  } else if (screens.sm) {
    modalWidth = 300;
  } else {
    modalWidth = 200;
  }

  const updateUserList = (newUser) => {
    setLocation((prevUser) => {
      // Check if the user is being added or updated
      const index = prevUser.findIndex(
        (user) => user.userid === newUser.userid
      );
      if (index === -1) {
        // Add new user
        return [...prevUser, newUser];
      } else {
        // Update existing user
        const updatedUsers = [...prevUser];
        updatedUsers[index] = newUser;
        return updatedUsers;
      }
    });
    setFilteredLocation((prevFilteredUser) => {
      const index = prevFilteredUser.findIndex(
        (user) => user.userid === newUser.userid
      );
      if (index === -1) {
        // Add new user
        return [...prevFilteredUser, newUser];
      } else {
        // Update existing user
        const updatedUsers = [...prevFilteredUser];
        updatedUsers[index] = newUser;
        return updatedUsers;
      }
    });
    fetchData();
  };

  return (
    <DefaultLayout>
      <Card style={{ width: "100%", minHeight: "600px", height: "100%" }}>
        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
            <h2>Area List</h2>
          </Col>
          <Col xs={24} sm={24} md={10} lg={10} xl={10}>
            <Input
              style={{ width: "100%", height: "45px" }}
              placeholder="Search Area,City,Hospital"
              onChange={(e) => {
                const value = e.target.value.toLowerCase();
                setFilteredLocation(
                  location.filter((item) =>
                    Object.values(item).some(
                      (field) =>
                        field && field.toString().toLowerCase().includes(value)
                    )
                  )
                );
              }}
            />
          </Col>
          <Col
            xs={24}
            sm={24}
            md={6}
            lg={6}
            xl={6}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              style={{
                backgroundColor: "#6499f1",
                color: "white",
                fontSize: "14px",
                fontWeight: "600",
                borderRadius: "10px",
                width: "100%",
                height: "48px",
                maxWidth: "200px",
              }}
              onClick={showModal}
            >
              Create Area
            </Button>
          </Col>
        </Row>
        <Row>
          <Col xs={24} sm={24} md={22} lg={20} xl={24}>
            <Table
              columns={columns}
              dataSource={filteredLocation}
              rowKey="id"
              pagination={{
                current: currentPage,
                pageSize: pageSize,
                total: total,
                onChange: handlePageChange,
                showSizeChanger: false,
              }}
              scroll={{ x: true }}
            />
          </Col>
        </Row>
        <Modal
          title={isEditing ? "Edit Area" : "Create Area"}
          // title={"Create City"}
          visible={isModalVisible}
          onCancel={closeModal}
          footer={null}
          width={modalWidth}
        >
          {isEditing ? (
            <EditArea data={selectedRecord} />
          ) : (
            <AddArea updateUserList={updateUserList} />
          )}
        </Modal>
      </Card>
    </DefaultLayout>
  );
};

export default AreaList;
